import { Button, Card, Col, Drawer, Icon, notification, Row } from 'antd'
import React from 'react'
import { connect } from 'react-redux'
import { updateApprovedAbstractFxn, generateGraphicalAbstractFxn } from '../actions'

class AbstractGraphicalRepresentationDrawer extends React.Component {
  state = {
    loading: false,
    isGenerating: false,
    generatedImageUrl: null
  }

  generateWithAI = async () => {
    const { abstract, dispatch } = this.props;

    this.setState({ isGenerating: true });
    
    try {
      const abstractText = abstract.abstract || abstract.abstractTitle || ''

      const result = await dispatch(generateGraphicalAbstractFxn({ abstractText, abstractId: abstract._id }))

      if (result && result.success && result.imageUrl) {
        this.setState({
          generatedImageUrl: result.imageUrl
        })
      }

    } catch (error) {
      console.error('AI Generation error:', error)
      notification.error({
        message: 'Generation Failed',
        description: (error.response && error.response.data && error.response.data.message) || 'Failed to generate graphical abstract with AI.'
      });
    } finally {
      this.setState({ isGenerating: false });
    }
  }

  handleSubmit = async () => {
    const { abstract, dispatch, onRefresh, onClose } = this.props
    const { generatedImageUrl } = this.state

    if (!generatedImageUrl) {
      notification.error({
        message: 'Missing Image',
        description: 'Please generate a graphical abstract using AI first.'
      })
      return
    }

    this.setState({ loading: true })

    let fd = new FormData()
    fd.append('obj', JSON.stringify({
      abstractId: abstract._id,
      graphicalAbstract: {
        path: generatedImageUrl,
        fileName: 'graphical_abstract.png'
      }
    }))

    let response = await dispatch(updateApprovedAbstractFxn(fd))
    this.setState({ loading: false })

    if (response && response.success) {
      this.setState({ generatedImageUrl: null })
      if (onRefresh) onRefresh()
      onClose()
    }
  }

  render() {
    const { loading, isGenerating, generatedImageUrl } = this.state
    const { visible, onClose, abstract } = this.props

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        width={'40%'}
        title={`Manage Graphical Abstract | Abstract No. - ${abstract.abstractNo || 'N/A'}`}
        destroyOnClose
      >
        <Card bordered={false}>
          <Row gutter={16}>
            <Col span={24} style={{ marginBottom: '20px' }}>
              {abstract.graphicalAbstract && abstract.graphicalAbstract.path && (
                <div style={{ marginBottom: '20px' }}>
                  <h4>Current Graphical Abstract:</h4>
                  <img src={abstract.graphicalAbstract.path} alt="Graphical Abstract" style={{ maxWidth: '100%', border: '1px solid #ddd', padding: '5px' }} />
                </div>
              )}
            </Col>
            
            {generatedImageUrl && (
              <Col span={24} style={{ marginTop: '20px', marginBottom: '20px' }}>
                <h4>AI Generated Preview:</h4>
                <img src={generatedImageUrl} alt="Generated Graphical Abstract" style={{ maxWidth: '100%', border: '1px solid #ddd', padding: '5px' }} />
              </Col>
            )}
            
            <Col span={24} style={{ marginTop: '20px' }}>
              <Button type="default" onClick={this.generateWithAI} loading={isGenerating} block style={{ marginBottom: '10px', backgroundColor: '#e6f7ff', borderColor: '#91d5ff', color: '#1890ff' }}>
                <Icon type="robot" /> Generate Graphical Abstract using AI
              </Button>
              
              <Button type="primary" onClick={this.handleSubmit} loading={loading} block disabled={!generatedImageUrl}>
                <Icon type="save" /> Save Generated Graphical Abstract
              </Button>
            </Col>
          </Row>
        </Card>
      </Drawer>
    )
  }
}

export default connect(null)(AbstractGraphicalRepresentationDrawer)

